import React, { useLayoutEffect, useState } from "react";

/** The element's rendered height, kept current as it resizes (for example when its text wraps). */
export const useElementHeight = (ref: React.RefObject<HTMLElement>): number => {
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const measure = () => setHeight(Math.ceil(element.getBoundingClientRect().height));
    const resizeObserver = new ResizeObserver(measure);
    resizeObserver.observe(element);
    measure();

    return () => resizeObserver.disconnect();
  }, [ref]);

  return height;
};
